import { ChangeEvent, ChangeEventHandler } from "react";
import styled from "styled-components";

import { Block, LISBlock } from "pwapi";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5em;
`;

const Control = styled.div`
  flex: 0;
`;

const Input = styled.input`
  opacity: 0;
  position: absolute;

  &:checked + label {
    background-color: var(--cerulean);
    color: var(--white);
    font-weight: 500;
  }
`;

const Label = styled.label`
  display: block;
  cursor: pointer;
  width: 100%;
  padding: 0.6em 0.5em;
  background-color: var(--cerulean20);
  border-radius: 0.25em;
  color: var(--cerulean);
  text-align: center;
  min-width: 50px;
  transition: background-color 0.5s, color 0.5s;
`;

export const optionsForPieceCount = (
  values: Block.piece_count[] | LISBlock.piece_count[],
  currentValue?: Block.piece_count | LISBlock.piece_count | null
) => {
  return values
    .filter((optionValue) => optionValue.length < 2)
    .map((optionValue) => ({
      value: optionValue,
      label:
        optionValue === "F" &&
        currentValue?.length &&
        currentValue?.length > 1 &&
        currentValue?.includes("F")
          ? "+F"
          : optionValue,
      id: optionValue,
      checked:
        currentValue?.length &&
        currentValue?.length > 1 &&
        currentValue?.includes("F")
          ? currentValue?.replace("F", "") === optionValue ||
            optionValue === "F"
          : !!currentValue && currentValue === optionValue,
    }));
};
export const onChangeForPieceCount = (
  currentValue: Block.piece_count | LISBlock.piece_count | null | undefined,
  setValue: (pieceCount: string | null) => void
) => {
  return (e: ChangeEvent<HTMLInputElement>) => {
    let pieceCount = e.target.value || null;
    if (e.target.value === "F") {
      if (currentValue?.includes("F")) {
        pieceCount = currentValue?.replace("F", "") || null;
      } else {
        pieceCount = (currentValue !== "0" ? currentValue || "" : "") + "F";
      }
    } else if (e.target.value !== "0") {
      if (currentValue?.includes(e.target.value)) {
        pieceCount = currentValue?.replace(e.target.value, "") || null;
      } else {
        pieceCount = e.target.value + (currentValue?.includes("F") ? "F" : "");
      }
    } else if (e.target.value === "0") {
      if (currentValue === e.target.value) {
        pieceCount = null;
      }
    }
    setValue(pieceCount);
  };
};

type SegmentedControlProps = {
  id?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onClick?: (e: React.MouseEvent) => void;
  options: {
    label: string;
    value: string;
    id?: string;
    checked?: boolean;
  }[];
  name: string;
};
const SegmentedControl = ({
  onChange,
  onClick,
  options,
  name,
}: SegmentedControlProps) => {
  return (
    <Wrapper id={`${name}`} aria-label={`${name}`}>
      {options.map((option) => {
        return (
          <Control key={`${name}_${option.id || option.value}`}>
            <Input
              type="checkbox"
              value={option.value}
              name={`${name}_${option.value}`}
              id={`${name}_${option.id || option.value}`}
              checked={option.checked}
              aria-label={`${name}_${option.id || option.value}`}
              onChange={onChange}
              onClick={onClick}
            />
            <Label htmlFor={`${name}_${option.id || option.value}`}>
              {option.label}
            </Label>
          </Control>
        );
      })}
    </Wrapper>
  );
};

export default SegmentedControl;
